import React from "react";
import Nav from "react-bootstrap/Nav";

import { Action } from "../Profile";

import "../../App.scss";

const HeaderNavIcons = () => {
  return (
    <div className="header-nav-icons">
      <Nav defaultActiveKey="/Classes">
        <Nav.Link href="">
          {/* <img src={HelpIcon} alt="Help" className="header-icons" /> */}
        </Nav.Link>
        <Nav.Link href="">
          <Action />
        </Nav.Link>
        {/* <Nav.Link href={CommonPages.UpdateProfile}>
                    <img
                        src={ProfileIcon}
                        alt="Profile"
                        className="header-icons"
                        onClick={() => Profile}
                    />
                </Nav.Link> */}
      </Nav>
    </div>
  );
}
export { HeaderNavIcons };
